import { TagType } from '../Services/PhotoService';

export const MAX_PHOTOS_PER_UPLOAD = 100;
export const MAX_UNREAD_NOTIFICATION_COUNT = 99;
export const MAX_RECENT_NOTIFICATIONS = 4;

export const PHOTO_DATE_FORMAT = 'MM/DD/YYYY';
export const ACCEPT_IMAGE_TYPE = 'image/jpeg,image/png,image/gif';

export class FRESHDESK {
    public static readonly WHERE = `https://tightknit.freshdesk.com/support/solutions/articles/43000430855-image-location-where-this-happened-`;
    public static readonly WHEN = `https://tightknit.freshdesk.com/support/solutions/articles/43000430856-image-date-when-this-happened-`;
    public static readonly FAQS = 'https://tightknit.freshdesk.com/support/solutions/';
    public static readonly OPTIONS_FOR_UPLOADING_PHOTOS = `https://tightknit.freshdesk.com/support/solutions/articles/43000430859-upload-photos-options-for-uploading-photos-into-tightknit-`;
    public static readonly MANAGE_FAMILY_GROUPINGS = `https://tightknit.freshdesk.com/support/solutions/articles/43000430858-add-family-how-best-to-create-and-manage-family-groupings-of-your-family-and-friends-`;
    public static readonly ADD_FAMILY = 'https://tightknit.freshdesk.com/support/solutions/articles/43000484485-add-family';

    public static readonly GET_STARTED = 'https://tightknit.freshdesk.com/support/solutions/articles/43000484338-get-started';
    public static readonly HELP_GETTING_STARTED = 'https://tightknit.freshdesk.com/support/solutions/articles/43000484342-would-you-like-help-getting-started-';
    public static readonly FAMILY_ADMINISTRATOR = 'https://tightknit.freshdesk.com/support/solutions/articles/43000484488-family-administrator';
    public static readonly YOUR_PHOTOS = 'https://tightknit.freshdesk.com/support/solutions/articles/43000484484-your-photos';
    public static readonly SHARE_A_STORY = 'https://tightknit.freshdesk.com/support/solutions/articles/43000484371-share-a-story';
    public static readonly KEEP_PRIVATE = 'https://tightknit.freshdesk.com/support/solutions/articles/43000484369-keep-private';
    public static readonly DELETE_STORY = 'https://tightknit.freshdesk.com/support/solutions/articles/43000484475-delete-story';
    public static readonly STORY_ALBUM_TITLE = 'https://tightknit.freshdesk.com/support/solutions/articles/43000484362-story-album-title';
    public static readonly CREATE_STORY = 'https://tightknit.freshdesk.com/support/solutions/articles/43000484347-create-story';
    public static readonly STORY_ALBUMS = 'https://tightknit.freshdesk.com/support/solutions/articles/43000484344-story-albums';
    public static readonly NEW_TICKETS = 'https://permanent.zohodesk.com/portal/en/newticket?departmentId=500343000000006907';

    // public static readonly  = '';
}

export const DuplicateConstants = {
    SUB_HEADER: `A photo with this same filename has previously been uploaded to Your Photos. Are the New Photo and Current Photo the same? Please click a button to select what action to take. `,
    HEADER: (fileName: string) => `Possible Duplicate: ${fileName}`,
    NEW_PHOTO: `New Photo`,
    CURRENT_PHOTO: `Current Photo`,
    DUPLICATE: `Duplicate - Skip the New Photo `,
    NO_DUPLICATE: `Not a Duplicate - Upload the New Photo`,
};

export const AddStoryConstants = {
    CANCEL: 'Cancel',
    CONFIRM: 'Add Story Album',
};

export const RemovalConfirmConstants = {
    REMOVE_TEXT: 'Yes, Remove',
    CANCEL_TEXT: 'Cancel',
};

export const AddFamilyMemberConstants = {
    INVITE_TO_FAMILY: `Invite to family`,
    INVITE_FAMILY_NAME: (name: string) => `Invite people to join the ${name} family`,
    MAX_AMOUNT_INVITE: (amount: number) =>
        'Sorry, you cannot add more than ' + amount + ' people to a family at one time',
    INVALID_EMAIL: 'Email was invalid, or user name did not match',
    NO_INVITES: 'You have not added any names or emails to be invited to the family',
    INVITE_PLACEHOLDER: 'Invite by email or name',
};

export const ResetPasswordConstants = {
    EMAIL_PLACEHOLDER: 'Email',
    PASSWORD_PLACEHOLDER: 'Password',
    CONFIRM_PASSWORD_PLACEHOLDER: `Confirm Password`,
    RESET_PASSWORD: 'Reset Password',
    LOGIN: `Login!`,
    HEADER: `Enter information to reset password`,
    REMEMBER_PASSWORD: 'Remember your password?',
    CATCH_ALL_ERROR:
        'Something went wrong when trying to change your password, please check that the email you entered matches the email the password reset was sent to. \nYour reset token may be expired, please re-send your password reset email and try again',
    PASSWORD_BEEN_RESET: 'Password has been reset',
    WRONG_LINK:
        'Something was wrong with the link provided to you, please go to your email and re-click on the link sent',
    PASSWORD_LENGTH: (length: number) => 'Please make your password ' + length + ' or more characters',
    NO_MATCH: 'Passwords did not match',
};

export const LoginConstants = {
    PRIVACY_POLICY: `Privacy Policy`,
    SIDE_SUB_HEADER:
        'TightKnit is inspired by those family “kitchen table” conversations of days gone by. Except now, loved ones can pull up a chair anytime, anywhere.',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    FORGOT_PASSWORD: 'Forgot your password?',
    PASSWORD_INPUT: 'Password',
    PASSWORD_PLACEHOLDER: 'Password (Required)',
    CONFIRM_PASSWORD_INPUT: 'Confirm Password',
    EMAIL_INPUT: 'Email',
    EMAIL_PLACEHOLDER: 'Email (Required)',
    NAME_INPUT: 'Full Name',
    NAME_PLACEHOLDER: 'Required',
    TOS_PREFIX: 'By joining TightKnit, you accept our',
    TOS: `Terms of Use`,
    LOGIN_HYPERLINK: 'Create New Account',
    LOGIN_PRETEXT: 'Not a member?',
    SIGNUP_HYPERLINK: 'Log in',
    SIGNUP_PRETEXT: 'Already have an account?',
    FORGOT_HYPERLINK: 'Log In',
    LOGIN_BUTTON: 'Log In',
    SIGNIUP_BUTTON: 'Sign Up Now, Free For Life',
    FORGOT_BUTTON: 'Send Reset Email',
    RESET_BUTTON: 'Reset Password',
    HEADER_LOGIN: 'Member Login',
    HEADER_SIGNUP: 'Create Account (beta)',
    HEADER_FORGOT: 'Forgot your password?',
    HEADER_RESET: 'Reset Password',
    REQUIRED_FIELD: 'This field is required',
    INVALID_PASSWORD: 'Password must be at least 6 characters',
    INVALID_CONFIRM_PASSWORD: 'Passwords are invalid or do not match',
    EMAIL_INVALID: 'Email is invalid',
    MUST_ACCEPT_TOS: 'You must accept the Terms & Conditions',
    EMAIL_IS_REQUIRED: 'Email and password are required',
    EMAIL_BAD_FORMAT: 'Email is poorly formatted',
    INCORRECT_EMAIL_PASSWORD: 'Email or password is incorrect',
    UNRECOGNIZED_ERROR: 'An unrecognized error occurred. Please try again later',
    ACCOUNT_EXISTS: 'An account already exists with this email. Did you mean to log in?',
    PASSWORD_CHANGED_HEADER: 'Password Updated',
    PASSWORD_CHANGED_CONFIRM: 'OK',
    RESET_EMAIL_SENT_HEADER: (email: string) => `An email with further instructions has been sent to ${email}`,
    RESET_EMAIL_SENT_CONFIRM: 'OK',
    LOGIN_SIDE_HEADER: `We hope you’ve been enjoying the fun of collaborative storytelling with your family and friends. We’d love to hear what you think at <a href="mailto:hello@tightknit.com" style="cursor:pointer; color: white;">hello@tightknit.com</a>`,
    SIGNUP_SIDE_HEADER: `Welcome to TightKnit, a place for you to discover, enjoy and preserve the stories of your family and friends, together.`,
    FOOTER: `Everything you do on the TightKnit™ platform is private and secure. This is very important to us. Your content is your content, and nobody else’s. TightKnit simply provides a place for you to manage your content, and to allow your family stories to flourish.`,
    MOBILE_HEADER:
        'We notice you are joining us from your mobile device. Mobile is coming soon! For optimal viewing experience, please access TightKnit from your laptop or desktop browser.',
    MOBILE_BODY:
        'If you wish to proceed with signing up and/or logging in from your phone, we recommend you put it in Landscape mode (turn your phone on its side) for easier viewing.',
    HELLO_NEW_FRIEND: `Hello new friend.`,
    CONTINUE_TO_DESKTOP: 'Continue to desktop site',
};

export const OnboardingFinishedConstants = {
    JOIN_ALBUM_NOW: `Join Story Album Now`,
    INVITED_FINISHED_HEADER: 'That’s it, you are ready to join your family’s story album. Easy, right?',
    INVITED_FINSIHED_BODY:
        'With a simple click here, you can check out a story in progress, and even add your own memories and photos if you want!',
    INVITED_FINISHED_FOOTER: 'Enjoy!',
    CREATED_STORY: 'You’ve created a story album with a relevant name for your photos. Well done!',
    CREATED_FAMILY: 'You’ve created a family to share your story with.',
    KEPT_STORY_PRIVATE: 'Now you can write or add audio comments, and begin watching the memories multiply.',
    ADDED_PHOTOS: 'You’ve added one photo (or more!) and maybe even provided some facts about them. Looks good!',
    WRITE_COMMENTS:
        'You’ve invited family to join in the storytelling or have chosen to keep it private for now. Nice job!',
    BUTTON_TEXT: 'Enter Your Story Album Now',
    MAIN_HEADER: `You're all set!`,
    FINISH: 'Finish',
    PARAGRAPHS: [
        'Just remember, you’ll have the opportunity to add more photos and story albums at any time! And for each ' +
        'story album, you decide with whom to share it, whether a previously entered family or a brand new one.',

        'Go to your first story album and start the conversation now!',

        'Then share it with a family, and watch the memories multiply!'
    ],
};

export const OnboardingHowItWorksConstants = {
    UPLOAD_PHOTOS: 'Second, securely add a photo or photos to your story album. All it takes is one to get started.',
    CREATE_FAMILIES:
        'Fourth, invite family and friends to join your story album and share their memories about your photo. Or keep your story album private for now.',
    CREATE_STORIES:
        'First, create a story album. It will be a home for your photos and the stories behind them. Give it a name that reflects its contents.',
    WRITE_COMMENTS:
        'Third, consider providing some facts about each photo if you know them (e.g. where/when.) Or come back and do it at a later date.',
    FINAL_INSTRUCTION: 'Now, sit back and enjoy the banter as the memories unfold!',
    HEADER: 'How it works',
    SETUP_PROFILE: 'Let’s Create a Story Album',
};

export const OnboardingIntroConstants = {
    HEADER: `Hey there`,
    SUB_HEADER: `In four simple steps, you’ll be sharing photos and stories with your family and friends. <br/><br/><b>Here's how Tightknit works.</b>`,
    SUB_HEADER_SECOND: ` Let's show you around.`,
    BUTTON_TEXT: 'Get Started',
};

export const MainPageNavigatorConstants = {
    STORY_ALBUMS: 'Story Albums',
    SHOULD_CREATE_STORY: 'You should create a story album!',
    NO_ALBUM: 'No Story Albums',
    GRID_INSTRUCTIONS: 'Click on a Story Album to Open it',
    YOUR_STORY: 'Your Story',
    CREATE_ALBUM: 'Create Album',
    ADD_PHOTOS: 'Add Photos',
    ADD_FAMILY: 'Add Family',
    LOGOUT: 'Log Out',
    ACCOUNT_SETTINGS: 'Account Settings',
    NOTIFICATION_HEADER: 'Latest Notifications',
    NOTIFICATION_FOOTER: 'View all notifications',
    MARK_ALL_AS_READ: 'Mark all as read',
    ADD_MEMBER: 'Add Member',
    ADD_PHOTO: 'Add Photo',
    SUPPORT_LINK: 'Support / FAQs',
    LOADING_ALL: 'Loading all photos and stories…',
};

export const PhotoViewerConstants = {
    NEXT_PHOTO: 'Next Photo',
    NOT_FINISHED_COMMENT_HEADER: `You didn't 'Add' your comment.`,
    NOT_FINISHED_COMMENT_SUB_HEADER: 'If you continue, an unadded comment will be deleted. What do you want to do?',
    LOADING: `Loading new photos for story album...`,
    ADDED_BY: (photoUploaderName: string) => `Added by ${photoUploaderName} on`,
    SHARED_WITH: 'Shared with',
    STORY: 'Story',
    ADD_PHOTO: 'Add Photo',
    WRITE: 'Write',
    RECORD: 'Record',
    ADD_TO_STORY: 'Add to the story',
    ADD: 'Add',
    REPLY: 'Reply',
    HIDE_REPLIES: 'Hide Replies',
    NUMBER_OF_REPLIES: (count: number) => `${count} Replies`,
    EDIT: 'Edit',
    ADD_FAMILY_MEMBER: 'Add Family Member',
    PRIVATE_STORY: 'Private story album',
    EXIT_CANCEL: 'Remain Here',
    EXIT_CONFIRM: 'Leave Page',
    DELETE_UNADDED_DATA: 'Delete Unadded Comment',
    ERROR_NO_PHOTOS: `Something went wrong. This album has no photos.`,
};

export const AddPhotoConstants = {
    FOR_STORY: `For Story: `,
    MAX_UPLOAD_LIMIT: `You cannot upload more than ${MAX_PHOTOS_PER_UPLOAD} at one time`,
    NOT_SUPPORTED: `was not uploaded because only JPG and JPEG file types are supported`,
    GO_BACK: 'Go Back',
    SKIP_FOR_NOW: 'Skip for now',
    OK: 'Ok',
    CANNOT_UPLOAD_MORE: (amount: number) =>
        `You cannot upload more than ${MAX_PHOTOS_PER_UPLOAD} photos at one time, ${amount} photos were not added`,
    UPLOADING_PHOTOS: 'Uploading Photos',
    ROTATE: 'Rotate',
    HEADER: 'Add Photos',
    ACTION_TEXT: 'Drop photos here',
    SUB_TEXT: 'JPG files, 10MB max size',
    BUTTON_TEXT: 'Or Choose Files',
    ADD_PHOTOS_HEADER: 'Add Photos',
    CONFIRM_TEXT: 'Done',
    DROP_MORE: 'Drop more photos here',
    CHOOSE_FILES: 'Choose Files',
    REMOVE: 'Remove',
    REQUIRED: 'Required',
    CITY_STATE: 'City, State',
    ADD_PHOTOS: `Add a photo to start your story album`,
    NEXT_BUTTON: 'Upload',
    EXIT_HEADER: 'Are you sure you want to leave this activePage without saving?',
    EXIT_SUB_HEADER: 'This information will be lost',
    EXIT_CANCEL: 'Go Back',
    EXIT_CONFIRM: 'Leave Page',
    STEP_TWO: `Add one or more photos to start your story album`,
    STEP_THREE: `Add where and when each photo was taken<br/>(or come back and provide these facts later)`,
    OCCURRED_WHERE: 'Occurred where?',
    FILE_NAME: 'File name',
    OCCURRED_WHEN: 'Occurred when?',
    DATE_PLACEHOLDER: 'MM / DD / YYYY',
};

export const OnboardingFamilyConstants = {
    ADD: 'Add',
    FIRST_NAME_HEADER: 'First Name',
    GO_BACK: 'Go Back',
    EMAIL_HEADER: 'Email',
    OPTIONAL_PLACEHOLDER: 'Optional',
    REQUIRED_PLACEHOLDER: 'Required',
    FAMILY_NAME_HEADER: 'Family Name',
    FAMILY_MEMBERS: 'Family members',
    TOP_SUB_TEXT: `We’ll send each family member a personalized email. At least one`,
    BOTTOM_SUB_TEXT: `additional person is required to create a Family. You can always add more later.`,
    SUB_HEADER: 'Give your Family a name',
    HEADER: `Invite your family and friends`,
    NEXT_BUTTON: 'Finish',
    ADD_FAMILY: 'Add Family',
    CREATE_FAMILY: 'Create Family',
    SKIP: 'Skip',
    BOTTOM_TEXT:
        'We’ll send each family member a personalized email, indicating you’ve invited them to join in the storytelling around one or more photos in your TightKnit story album.',
};

export const OnboardingCreateStoryConstants = {
    STEP_FOUR: `Step 4: Invite your family and friends`,
    BOTTOM_SUB_HEADER: `Storytelling around a photo is best with family and friends. Invite one or more people to your story album to get the conversation going. You can also choose to keep it private for now as you assemble photos, storytelling thought-starters, or questions to share out with people soon. `,
    SKIP_ADD_LATER: 'Skip, Add Photos Later',
    ADD_PHOTOS_NOW: 'Add Photos Now',
    CONTINUE: 'Continue',
    GO_BACK: 'Go Back',
    CANNOT_BE_UNDONE: `This cannot be undone`,
    CREATE_NEW_FAMILY: 'Create New Family',
    SHARE_WARNING: 'If you share this story album, you cannot unshare it in the future',
    NO_FAMILY_NEXT: 'Finish',
    FAMILY_NEXT: 'Add Family',
    ADD_PHOTOS: 'Add Photos',
    CREATE_ALBUM: 'Create Album',
    CANCEL: 'Cancel',
    HEADER: `Create a story album`,
    SUB_HEADER: `Share with your friends and family`,
    SECOND_INSTRUCTION: 'Choose to share your story album with a family or keep it private.',
    NO_SHARE: 'Not shared with anyone',
    KEEP_PRIVATE_HEADER: 'Keep Private',
    SHARE_HEADER: 'Share',
    SHARE_INSTRUCTIONS: `We'll add who you can share it with next.`,
    REQUIRED_STORY_NAME: 'Album name is required',
    EXIT_HEADER: 'Are you sure you want to leave this activePage without saving?',
    EXIT_SUB_HEADER: 'This information will be lost',
    EXIT_CANCEL: 'Go Back',
    EXIT_CONFIRM: 'Leave Page',
    MUST_ADD_NAME: 'You must add a title to the story album to create it',
    OK: 'Ok',
    STORY_CREATED: (name: string) => {
        return `Your story album ${name} has been created`;
    },
};

export const OnboardingSetupProfileConstants = {
    SAVE: 'Save',
    REQUIRED_PLACEHOLDER: 'Required',
    OPTIONAL_PLACEHOLDER: 'Optional',
    FIRST_NAME_HEADER: 'First Name',
    LAST_NAME_HEADER: 'Last Name',
    EMAIL_HEADER: 'Email',
    NICKNAME_HEADER: 'Nickname',
    LOCATION_HEADER: 'Where you live',
    DATE_OF_BIRTH_HEADER: 'Date of Birth',
    BIRTH_PLACE_HEADER: 'Birth Place',
    HEADER: `Let's set up your profile.`,
    DROPZONE: 'Drop photo here',
    PHOTO_TYPES: 'JPG files, 10MB max size.',
    CHOOSE_FILES: 'Choose Files',
    NEXT_BUTTON: 'Create Album',
    PROFILE_PICTURE: 'Profile picture',
    REMOVE: 'Remove',
    REPLACE: 'Replace',
    REQUIRED_FIELD: 'This field is required',
    ACCOUNT_BEING_CREATED: 'Your account is being created…',
    ACCOUNT_CREATED: 'Account created',
    OK: 'OK',
    FINISH: 'Finish',
    ADD_PHOTO: 'Add profile photo',
};

export const PhotoDetailConstants = {
    SERVER_ISSUE: 'Encountered server issue with deleting photo',
    ARE_YOU_SURE_REMOVE: `Are you sure you want to remove this photo from the album?`,
    NOT_A_PART_OF_STORY: 'This photo is not a part of any album',
    CANNOT_BE_UNDONE: 'This cannot be undone',
    ARE_YOU_SURE_DELETE: 'Are you sure you want to delete this photo?',
    ROTATE: 'Rotate',
    REQUIRED_PLACEHOLDER: 'Required',
    LOCATION_PLACEHOLDER: 'City, State',
    REMOVE_BUTTON: 'Remove',
    CONFIRM_TEXT: 'Save',
    CANCEL_TEXT: 'Delete Photo',
    CANCEL_DELETE_PHOTO: 'Cancel',
    WARNING_DELETING_PHOTO: 'Deleting this photo will remove it from these stories:',
    OK: 'OK',
};

export const NotificationsConstants = {
    NO_NOTIFICATIONS: 'Check back for new notifications',
    TYPE_COLUMN: 'Type',
    BODY_COLUMN: 'Body',
    MARK_AS_READ_COLUMN: 'Mark all as read',
    NOTIFICATION_BODY_TEXT: (fullName: string) => ({
        TEXT_COMMENT: (storyName: string) => `${fullName} added a comment on a photo in the story album ${storyName}`,
        AUDIO_COMMENT: (storyName: string) => `${fullName} recorded a comment on a photo in the story album ${storyName}`,
        SHARED_STORY: (storyName: string, familyName: string) =>
            `${fullName} shared the story album ‘${storyName}’ with your family ‘${familyName}’.`,
        ADDED_TO_FAMILY: (familyName: string) => `${fullName} added you to the family ‘${familyName}’.`,
        FAMILY_NAME_CHANGE: (familyName: string) =>
            `${fullName} has updated the name of your family to '${familyName}'`,
        ACCEPTED_INVITE: (familyName: string) => `${fullName} has accepted your invite to join '${familyName}'`,
        PHOTO_ADDED: (storyName: string, count: number) =>
            `${fullName} has added ${count > 1 ? count + ' photos' : 'a photo'} to the story album ${storyName}`,
    }),
};

export function getDisplayNameFromTagType(tagType: TagType): string {
    switch (tagType) {
        case TagType.DATE:
            return 'Occurred when?';
        case TagType.FILENAME:
            return 'File Name';
        case TagType.LOCATION:
            return 'Occurred where?';
        default:
            throw new Error(`Invalid type provided to getDisplayNameFromTagType: ${tagType}`);
    }
}

// export function getTagTypeFromName(name: string): TagType {
//     const tagType = TagType[name.toUpperCase()];
//     if (tagType) {
//         return tagType as TagType;
//     }
//     throw new Error(`Invalid tag type name provided to getTagTypeFromName: ${name}`);
// }

export const FamilySettingsConstants = {
    ADD_MEMBER_BUTTON: `Add Member`,
    HAVENT_JOINED: `You have not joined any families yet`,
    CREATE_A_FAMILY: 'You should create a family!',
    NO_FAMILY: 'No Families',
    ADD_FAMILY: 'Add Family',
    ADD_MEMBER: (name: string) => `Add member to: ${name}`,
    FIRST_NAME: 'First Name',
    EMAIL: 'Email',
    FAMILY_SETTINGS: 'Family Settings',
    REQUIRED_PLACEHOLDER: 'Required',
    ADD: 'Add',
    FAMILY_NAME: 'Family Name',
    SAVE: 'Save',
    REMOVE: 'Remove',
    PLUS_ONE: '+1',
    LEAVE_BUTTON: 'Leave',
    MEMBER_COUNT: (length: number) => length + ' member' + (length > 1 ? 's' : ''),
    EXIT_HEADER: 'Are you sure you want to leave this activePage without saving?',
    GO_BACK: 'Go Back',
    LEAVE_PAGE: 'Leave Page',
    EXIT_SUB_HEADER: 'This information will be lost',
    INVITE_CONFIRM: 'An invite has been sent to',
    OK: 'Ok',
    INVITE_SENT: 'Invite Sent',
    INVITE_FAILED_FAMILY: (email: string) => `Invite was not sent because ${email} is already a part of this family`,
    INVITE_FAILED_INVITE: (email: string) =>
        `Invite was not sent because ${email} has already been invited to this family`,
};

export class ShareSettingsConstants {
    public static readonly HEADER = 'Share Settings';
    public static readonly SHARE_TAB = 'Share';
    public static readonly CANCEL = 'Cancel';
    public static readonly REMAIN_HERE = 'Remain Here';

    public static readonly SHARED_WITH = `Shared with = `;
    public static readonly UNSAVED_CHANGES = `Any unsaved changes will be lost`;
    public static readonly LEAVE_PAGE = `Leave Page`;
    public static readonly SHARE_WARNING = `Once an album is shared it can't be unshared`;
    public static readonly CONTINUE = 'Continue';
    public static readonly GO_BACK = 'Go Back';
    public static readonly CANNOT_BE_UNDONE = `This cannot be undone`;
    public static readonly CREATE_NEW_FAMILY = 'Create New Family';
    public static readonly SAVE = 'Save';
    public static readonly ONE_FAMILY_PER_SHARE = 'An album can only be shared with one family.';
    public static readonly CANNOT_UNDO_SHARE = 'Sharing an album cannot be undone';
    public static readonly ARE_YOU_SURE = `You selected a family to share with but haven't saved yet. Are you sure you want to leave?`;
    public static readonly CANNOT_SHARE = `You cannot share an album with no photos`;
}

export const StorySettingsConstants = {
    WARNING: 'Warning',
    SHARED_WITH: `Shared with: `,
    CONFIRM: 'You will lose all the progress on photos you have uploaded by searching the Your Photos tab',
    SUCCESS_UPLOAD: (length: number, title: string) => `${length} photos successfully added to ${title}`,
    UNSAVED_CHANGES: `Any unsaved changes will be lost`,
    LEAVE_PAGE: `Leave Page`,
    SHARE_WARNING: `Once an album is shared it can't be unshared`,
    CONTINUE: 'Continue',
    GO_BACK: 'Go Back',
    CANNOT_BE_UNDONE: `This cannot be undone`,
    CREATE_NEW_FAMILY: 'Create New Family',
    ALBUM_SETTINGS: 'Album Settings',
    HEADER: 'Story Album Settings',
    SAVE: 'Save',
    REQUIRED_PLACEHOLDER: 'Required',
    ALBUM_NAME: 'Album Name',
    ADD_PHOTOS: 'Add Photos',
    YOUR_PHOTOS: 'Your Photos',
    UPLOAD: 'Upload',
    NO_PHOTOS: 'No photos yet',
    NO_PHOTOS_SUBTEXT: `You've not added any photos yet.`,
    KEEP_PRIVATE_HEADER: 'Keep Private',
    SHARE_HEADER: 'Share',
    NO_SHARE: 'Not shared with anyone',
    EXIT_HEADER: 'Are you sure you want to leave this activePage without saving?',
    EXIT_SUB_HEADER: 'This information will be lost',
    EXIT_CANCEL: 'Go Back',
    EXIT_CONFIRM: 'Leave Page',
    CANNOT_UNDO_SHARE: 'Sharing an album cannot be undone',
    DELETE_ALBUM: 'Delete Album',
    CANNOT_DELETE: 'You cannot delete or update share preferences on an album already shared to a family',
    ARE_YOU_SURE_DELETE: 'Are you sure you want to delete this album?',
    ARE_YOU_SURE_CLOSE: 'Are you sure you want to cancel?',
    CANNOT_SHARE: `You cannot share an album with no photos`,
};

export const PhotoTabConstants = {
    ADD_SOME_PHOTOS: 'You should add some photos!',
    NO_PHOTOS: 'No Photos',
    YOUR_PHOTOS: 'Your Photos',
    ADD_PHOTOS: 'Add Photos',
    DELETE_IN_PROGRESS: 'Deleting photos…',
    DESELECT_ALL: 'Deselect All',
    CREATE_ALBUM: 'Create Album',
};

export const EmailSettingsConstants = {
    HEADER: 'Receive email notifications',
    OK: 'OK',
    EXIT_HEADER: 'Your email preferences have been saved',
    SAVE: 'Save',
};

export const ProfileTabContansts = {
    EXIT_HEADER: 'Your profile has been updated',
    OK: 'OK',
    SAVE: 'Save',
    UNSAVED_PROMPT: 'You have unsaved changes that will be lost if you leave this activePage.',
};

export const ExternalUrlConstants = {
    TOS_URL: 'https://www.tightknit.com/terms-of-use/',
    PRIVACY_POLICY_URL: 'https://www.tightknit.com/privacy-policy/',
};



// WEBPACK FOOTER //
// ./src/Config/UIConstants.ts